import { PaymentStatus, DocumentStatus, PAYMENT_STATUS_LABELS, DOCUMENT_STATUS_LABELS, PAYMENT_STATUS_COLORS, DOCUMENT_STATUS_COLORS } from '../types/statuses';

export const getPaymentStatusLabel = (status: PaymentStatus): string => {
  return PAYMENT_STATUS_LABELS[status] || status;
};

export const getDocumentStatusLabel = (status: DocumentStatus): string => {
  return DOCUMENT_STATUS_LABELS[status] || status;
};

export const getPaymentStatusColor = (status: PaymentStatus): string => {
  return PAYMENT_STATUS_COLORS[status] || '#6c757d';
};

export const getDocumentStatusColor = (status: DocumentStatus): string => {
  return DOCUMENT_STATUS_COLORS[status] || '#6c757d';
};
